var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPeople2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#62D3A5",
  d: "M5.76 7.72c2.587 0 4.203-2.8 2.91-5.04A3.36 3.36 0 0 0 5.76 1C3.174 1 1.557 3.8 2.85 6.04a3.36 3.36 0 0 0 2.91 1.68M.16 14.44c0-4.31 4.667-7.005 8.4-4.85a5.6 5.6 0 0 1 2.8 4.85c0 .31-.25.56-.56.56H.72a.56.56 0 0 1-.56-.56"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#269D84",
  fillRule: "evenodd",
  d: "M12.68 15h2.6c.31 0 .56-.25.56-.56a5.6 5.6 0 0 0-5.87-5.593 6.99 6.99 0 0 1 2.79 5.593q-.001.294-.08.56M9.268 7.578c2.477.746 4.832-1.469 4.24-3.987a3.36 3.36 0 0 0-4.24-2.448A4.74 4.74 0 0 1 10.52 4.36a4.74 4.74 0 0 1-1.252 3.218",
  clipRule: "evenodd"
})));
export default SvgPeople2;